module.exports = __webpack_public_path__ + "img/saishianpai-left-icon.becaf8d0.png";